import React from "react";
import { RCCBadge, RCCGrid, RCCIcon } from "react-common-components";
import Card from "src/components/Card";
import InfiniteScrollWithoutFetch from "src/components/InfiniteScrollWithoutFetch";
import DivGrouper from "src/components/ListCards/styles";
import Photo from "src/components/Photo";
import { useTranslation } from "src/context/Translations/context";
import formatDate from "src/utils/formatDate";
import { AuditType, AuditSituation, IAudits, ICardAudits } from "../interface";
import { DivWithWrap , DivFlexColumn, OverflowSpan } from "../styles";


const CardAudits: React.FC<ICardAudits> = ({
	data,
	options,
	filter
}) => {
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;
	const { translate, currentLanguage } = useTranslation();

	const colorCard = (dataAudits: IAudits) => {
		let color: "blue" | "purple" | "red" | "green" | "grey" | "black";
	
		switch(dataAudits.adb001Situacao){
		case AuditSituation.OPENED:
			color = "purple";
			break;
		case AuditSituation.IN_AUDIT:
			color = "blue";
			break;
		case AuditSituation.FINISHED:
			color = "green";
			break;
		default: 
			color = "green";
			break;
		}
		return color;
	};

	
	const colSituation = (row: any) => {

		let color: "blue" | "purple" | "red" | "green" | "grey" | "black";
		let text = "";

		switch(row.adb001Situacao){
		case AuditSituation.OPENED:
			text = translate("Aberta");
			color = "purple";
			break;
		case AuditSituation.IN_AUDIT:
			text = translate("Em Auditoria");
			color = "blue";
			break;
		case AuditSituation.FINISHED:
			text = translate("Concluída");
			color = "green";
			break;
		default: 
			color = "green";
			break;
		}

		return (
			<>
				<DivFlexColumn>
					<RCCBadge color={row.adb001Tipo === AuditType.EXTERNAL ? "grey" : "black"} styleInline="padding: 2px 8px; font-size: 0.78rem;">{translate(row.type)}</RCCBadge>
				</DivFlexColumn>

				<DivFlexColumn>	
					<RCCBadge color={color} styleInline="padding: 2px 8px; font-size: 0.78rem;">{text}</RCCBadge>
				</DivFlexColumn>  
			</>
		);
	};


	return (
		<>
			<DivGrouper>
				<InfiniteScrollWithoutFetch 
					listElements={data}
					filter={filter}
					mapper={(audits : any) => (
						<Card
							color={colorCard(audits)}
							options={options(audits)}
							title={`${audits.fullTitle}`}
							hidePercentage
							key={`${audits.adb001Id}`}
						>
							<RCCGrid container item alignItems="center" >
							
								<DivWithWrap style={audits.adb001Dtinicioplan !== null ? { flexDirection: "column", alignItems: "baseline" } : {}}>
									<DivWithWrap>
										<RCCIcon name="calendar" size={16} color="var(--default-color-font)" />
										{formatDate(audits.adb001Dtinicioplan, currentLanguage)}
										
									</DivWithWrap>
								</DivWithWrap>	
								<DivWithWrap style={{marginRight: "0.5rem"}}>
									<Photo 
										name={audits.adb001Efa005Nome2}
										link={audits.adb001Efa005Imagem2 && `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${audits.adb001Efa005Imagem2}`}
										hover
									/>
									{audits.adb001Efa005Nome2}
								</DivWithWrap>					
							</RCCGrid>

							<p><b>{`${translate("Norma")}: `}</b> 
								<OverflowSpan>{audits.adb001Ada001Descricao}</OverflowSpan> 
							</p>
							<p><b>{`${translate("Setor")}: `}</b> 
								<OverflowSpan>{audits.adb001Taa001Descricao}</OverflowSpan> 
							</p>
							<p><b>{`${translate("Processo")}: `}</b> 
								<OverflowSpan>{audits.adb001Taa005Descricao}</OverflowSpan> 
							</p>

							<RCCGrid container item alignItems="center" >
								{colSituation(audits)}
							</RCCGrid>
						</Card>	
					)}
				/>		
			</DivGrouper>
		</>
	);

};

export default CardAudits;
